__turbopack_context__.v({
  "table": "TaxYearlyReportDesktopDetails-module-scss-module__PxDj_W__table",
});
